import React from 'react';
import '../styles/CTASection.css';
import ContactButton from './ContactButton';

const CTASection: React.FC = () => {
  return (
    <section className="cta-new-section">
      <div className="cta-new-container">
        <div className="cta-new-content">
          <div className="cta-new-text">
            <h2 className="cta-new-title">Ready to Transform Your Business?</h2>
            <p className="cta-new-subtitle">
              Partner with ReventLabs to leverage cutting-edge technology solutions
              <br />
              tailored to your specific challenges.
            </p>
          </div>
          
          <div className="cta-new-button-wrapper">
            <ContactButton variant="border">
              Get Started
            </ContactButton>
          </div>
        </div>
        
        {/* Geometric decoration */}
        <div className="cta-new-decoration">
          <svg className="cta-new-lines" viewBox="0 0 400 200" fill="none">
            <path d="M0 50 Q100 20 200 50 T400 50" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            <path d="M0 80 Q100 50 200 80 T400 80" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            <path d="M0 110 Q100 80 200 110 T400 110" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            <path d="M0 140 Q100 110 200 140 T400 140" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
            <path d="M0 170 Q100 140 200 170 T400 170" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default CTASection; 